import React, { Component } from "react";
import MoneyInput, {cleanValue} from "../../money-input/MoneyInput";
import { MoneyInput as SparkMoneyInput } from "react-spark";

class LoanAmount extends Component {
  get validation() {
    const { minAmount, maxAmount } = this.props;

    return {
      validateOn: ["keyup"],
      required: true,

      checkValidity: value => {
        const cleanedValue = cleanValue(value);
        const amount = parseInt(cleanedValue);

        if (!SparkMoneyInput.pattern.test(value)) {
          return {
            isValid: false
          };
        }
        if (amount < minAmount) {
          return {
            isValid: false,
            inputAttr: "minlength"
          };
        }
        if (amount > maxAmount) {
          return {
            isValid: false,
            inputAttr: "maxlength"
          };
        }

        return {
          isValid: true
        };
      },
      message: {
        default: "Please enter a valid loan amount",
        minlength: `Your minimum loan amount is $${minAmount}`,
        maxlength: `The maximum loan amount is $${maxAmount}`
      }
    };
  }
  render() {
    const { className, value } = this.props;
    return (
      <MoneyInput
        id="requestedAmount"
        name="requestedAmount"
        placeholder="Enter Loan Amount"
        label=" &zwnj;"
        validation={this.validation}
        value={value}
        className={className}
      />
    );
  }
}

export default LoanAmount;
